module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/picture-o-9d816fb20d608d36a6e04acab696cc4f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/picture-o.svg
// module id = W9CC
// module chunks = 24